
import React, { useEffect } from 'react'
import Navbar from '../../components/modules/Navbar'
import './DevenirPartStyles.css'
import {BsFileArrowDown} from 'react-icons/bs'
import { Link as LinkScroll} from 'react-scroll';
import {ImQuotesLeft} from 'react-icons/im'
import {ImQuotesRight} from 'react-icons/im'
import Footer from '../../components/modules/Footer';
import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap';
import { useTranslation} from "react-i18next";
import plaquette2026 from '../../assets/partenaires/plaquette2026.pdf';



gsap.registerPlugin(ScrollTrigger);


const DevenirPart = () => {
    const {t} = useTranslation('common');
    const onLoad = () =>{
        gsap.timeline().fromTo("#on",
        {
            y: 50,
            opacity:0,
        },
        {
            y:0,
            opacity:1,
            duration:1.5,
        })
    }

    useEffect(() =>{
        onLoad();
    },[])

    return (
        <div>
           <Navbar scroll='true' />
           <div className='devenir-part'>
                <h1 id='on'> {t('devPartenaires.title')}</h1>
                <LinkScroll to='devenir-part-content' smooth={true}  offset={-10} duration={1000}> <BsFileArrowDown style={{color:'black'}} className='fleche-mazars'/></LinkScroll>
           </div>
           <div className='devenir-part-content' id='devenir-part-content'>
<h2> {t('devPartenaires.title2')}</h2>
<div className='devenir-part-inner'>
   <div className='semi-circle-part'> </div>
   <div className='devenir-part-inner-content'>
    <div className='devenir-part-quote'>
        <p> <ImQuotesLeft/> {t('devPartenaires.quote')} <ImQuotesRight/></p>
    </div>
    <div>
        <h4>{t('devPartenaires.text')}</h4>
        <div className='part-btn-content'>
            <a className='part-btn' href={plaquette2026} target='_blank' rel='noopener noreferrer'> {t('devPartenaires.btn1')}</a>
        <a className='part-btn' href='mailto:maxime.fauquet@student-cs.fr'> {t('devPartenaires.btn2')}</a>
            </div>
    </div>

   
</div>

            </div> 
           </div>
            
            <Footer/>
        </div>
    )
}

export default DevenirPart